import type { Band, Role } from './types.js';

/**
 * Band kategori — diambil dari formula Excel, bukan dari tabel tampilan.
 *
 *   =IF(x>85,"BERDAMPAK",IF(x>70,"MANDIRI",IF(x>50,"BERKEMBANG",
 *     IF(x>25,"BERTUMBUH","MERINTIS"))))
 *
 * Dokumen Kerangka Pikir memakai ambang berbeda (0–39/40–59/60–74/75–85) dan
 * DIABAIKAN atas keputusan klien.
 */
export const TBM_BANDS: Band[] = [
  { gt: 85, name: 'Berdampak', display: '86 - 100' },
  { gt: 70, name: 'Mandiri', display: '71 - 85' },
  { gt: 50, name: 'Berkembang', display: '51 - 70' },
  { gt: 25, name: 'Bertumbuh', display: '26 - 50' },
  { gt: null, name: 'Merintis', display: '<26' },
];

export const INDIVIDUAL_BANDS: Band[] = [
  { gt: 85, name: 'PELITA LITERASI', display: '86 - 100' },
  { gt: 70, name: 'PENGGERAK LITERASI', display: '71 - 85' },
  { gt: 50, name: 'PENGAMAL LITERASI', display: '51 - 70' },
  { gt: 25, name: 'PECINTA LITERASI', display: '26 - 50' },
  { gt: null, name: 'PEMULA', display: '<26' },
];

export const BAND_CHARACTERISTICS: Record<string, string> = {
  Berdampak:
    'TBM menjadi pusat belajar dan pemberdayaan masyarakat yang berkelanjutan serta memberi manfaat luas.',
  Mandiri:
    'TBM mampu mengelola program secara mandiri, membangun kolaborasi, dan menghasilkan dampak yang terukur.',
  Berkembang:
    'TBM mampu mengelola program secara terencana, rutin, dan mulai membangun jejaring serta partisipasi masyarakat.',
  Bertumbuh:
    'TBM mulai memiliki sistem pengelolaan dan program literasi, namun belum konsisten.',
  Merintis: 'TBM baru mulai membangun tata kelola dan program dasar.',
};

/**
 * Aturan pengisian dari sel catatan di Excel — ditampilkan sebagai panduan
 * di form penilaian.
 */
export const FILL_RULES = [
  'Berikan nilai pada setiap indikator dengan angka 1-4 sesuai dengan kriteria yang terpenuhi.',
  'Jika ada indikator yang masih ragu di kriteria mana, maka pilih kriteria yang nilainya lebih kecil.',
];

export const ROLE_LABELS: Record<Role, string> = {
  super_admin: 'Super Admin (SLI)',
  assessor: 'Assessor / Monev',
  tbm_manager: 'Pengelola TBM',
  pelita: 'Individu PELITA SLI',
};

export const PORTFOLIO_CATEGORY_LABELS = {
  prestasi: 'Prestasi',
  karya: 'Karya',
  publikasi: 'Publikasi',
} as const;

/**
 * Semua TBM masuk program serentak (dikonfirmasi klien), jadi tahun program
 * melekat pada periode: Sem 0 = Th 0, Sem 1–2 = Th 1, Sem 3–4 = Th 2, Sem 5–6 = Th 3.
 */
export function semesterToProgramYear(semester: number): number {
  if (semester <= 0) return 0;
  return Math.ceil(semester / 2);
}

export const PERIOD_PHASES = [
  'baseline',
  'monitoring_1',
  'monitoring_2',
  'monitoring_3',
  'monitoring_4',
  'monitoring_5',
  'endline',
] as const;

export const PHASE_LABELS: Record<string, string> = {
  baseline: 'Baseline',
  monitoring_1: 'Monitoring 1',
  monitoring_2: 'Monitoring 2',
  monitoring_3: 'Monitoring 3',
  monitoring_4: 'Monitoring 4',
  monitoring_5: 'Monitoring 5',
  endline: 'Endline',
};
